import { gql } from '@apollo/client'
import { PRODUCT_FRAGMENT } from '@/graphql/fragments/product'
import { LEADER_ADDRESS_DETAIL_FRAGMENT } from '@/graphql/fragments/addressDetail'

export const SOCIETY_FRAGMENT = gql`
  fragment SocietyFragment on Society {
    id
    formality {
      ...ProductFragment
    }
    name
    rcs
    projectType
    addressDetail {
      ...LeaderAddressDetailFragment
    }
    legalStatus {
      id
      name
      isMicro
    }
  }
  ${PRODUCT_FRAGMENT}
  ${LEADER_ADDRESS_DETAIL_FRAGMENT}
`
